import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";
import { Film } from "lucide-react";

const SceneBreakdown: React.FC<{
  scenes: AnalysisResult["storyboard_analysis"]["scenes"];
}> = ({ scenes }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
      <Film className="w-5 h-5" />
      Scene Breakdown ({scenes.length} scenes)
    </h3>

    <div className="space-y-3 max-h-96 overflow-y-auto">
      {scenes.map((scene, index) => (
        <div key={index} className="flex gap-3 p-3 bg-gray-50 rounded-md">
          <div className="flex-shrink-0 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-xs font-medium">
            {scene.scene_number}
          </div>
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              {scene.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SceneBreakdown;
